export const MEDIA_STATUS = Object.freeze({
  IDLE: 0,
  CANPLAY: 1,
  PLAYING: 2,
  ENDED: 3,
  ERROR: 4,
  PAUSED: 5,
} as const);

export type MediaStatusValue = (typeof MEDIA_STATUS)[keyof typeof MEDIA_STATUS];

export const DEFAULT_EVENT_STATE = Object.freeze({
  event: {} as Record<string, unknown>,
  event_results: {} as Record<string, unknown>,
  video_overlays: {} as Record<string, unknown>,
  overlays: {} as Record<string, unknown>,
  status: MEDIA_STATUS.IDLE,
  status_group: {
    HAS_ENDED: 0,
    VIDEO_IS_PLAYING: 0,
    VIDEO_CAN_PLAY: 0,
  },
  error: null as string | null,
  activeScheduleId: null as string | null,
});

export type MediaEventState = {
  event: Record<string, unknown> | null;
  event_results: Record<string, unknown> | null;
  video_overlays: Record<string, unknown>;
  overlays: Record<string, unknown>;
  status: number;
  status_group: {
    HAS_ENDED: number;
    VIDEO_IS_PLAYING: number;
    VIDEO_CAN_PLAY?: number;
    CAN_PLAY?: number;
  };
  error: string | null;
  activeScheduleId: string | null;
};

export const ENDED_STATUS: readonly number[] = [
  MEDIA_STATUS.ENDED,
  MEDIA_STATUS.ERROR,
];

export const CAN_PLAY_STATUS: readonly number[] = [
  MEDIA_STATUS.CANPLAY,
  MEDIA_STATUS.PLAYING,
  MEDIA_STATUS.PAUSED,
];

export const VIDEO_IS_PLAYING_STATUS: readonly number[] = [
  MEDIA_STATUS.PLAYING,
  MEDIA_STATUS.PAUSED,
];
